import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const ReqNoLongerMetAfterVerificationDaysExpired = ({ event }: { event: any }) => {
  const requirementsNotMet = event?.data?.requirementsNotMet || [];

  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} />
        <span> Requirement(s) no longer met after verification days expired: </span>
        <strong>{requirementsNotMet.join(', ')}</strong>
      </Box>
    </Box>
  );
};

export default ReqNoLongerMetAfterVerificationDaysExpired;
